export default __webpack_public_path__ + "static/testimonial-bg-v3-87b9f20281f5440c62f5b2011ec96b02.webp";